import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { SellOrderStatusBarProps } from '../../../../../SellOrders/SingleSellOrder/SellOrderStatusBar'
import SellInvoiceStatusBar, { SellInvoiceStatusBarNew } from '../../../SellInvoiceStatusBar'
import SellInvoiceFinishedStepButtons, { SellInvoiceFinishedStepButtonsNew } from '../SellInvoiceFinishedStepButtons'

type SellInvoiceFinishedStepHeaderProps = & SellOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const SellInvoiceFinishedStepHeaderDecider: React.FC<SellInvoiceFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellInvoiceFinishedStepHeaderDefault} NewComponent={SellInvoiceFinishedStepHeaderNew} {...rest} />
    )
}

const SellInvoiceFinishedStepHeaderDefault: React.FC<SellInvoiceFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellInvoiceStatusBar {...rest} />
            <SellInvoiceFinishedStepButtons {...rest} />
        </div>
    )
}

const SellInvoiceFinishedStepHeaderNew: React.FC<SellInvoiceFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellInvoiceStatusBarNew {...rest} />
            <SellInvoiceFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellInvoiceFinishedStepHeaderDecider